import React from 'react';

interface HeaderProps {
  mainHeading: {
    type: string;
    text: string;
    image: string;
  };
  tagline: string;
}

const Header: React.FC<HeaderProps> = ({ mainHeading, tagline }) => {
  
  return (
    <header className="pt-2 md:pt-4 mb-8">
      {mainHeading.type === 'image' && mainHeading.image ? (
        <div className="mb-4">
          <img 
            src={mainHeading.image} 
            alt={mainHeading.text || 'Coming Soon'} 
            className="max-w-full h-auto max-h-24"
          />
        </div>
      ) : (
        <h1 className="text-4xl md:text-5xl font-bold mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
          {mainHeading.text || 'Coming Soon'}
        </h1>
      )}
      
      {tagline && (
        <p className="text-xl md:text-2xl font-bold">
          {tagline}
        </p>
      )}
    </header>
  );
};

export default Header;